import * as React from 'react';
import * as ReactHighcharts from 'react-highcharts';

interface IAdditionalIndicesChartProps {
  givIndexAllEnabled?: boolean;
  givAppreciationEnabled?: boolean;
  givBalancedEnabled?: boolean;
  givOtherEnabled?: boolean;
  givPreservationEnabled?: boolean;
  givSmallEnabled?: boolean;
  givMediumEnabled?: boolean;
  givLargeEnabled?: boolean;
  foundationMarkIndexEnabled?: boolean;
  cpiEnabled?: boolean;
  spEnabled?: boolean;
  sfEnabled?: boolean;
  barclayEnabled?: boolean;
  alwaysEnabled?: boolean;
  displayClickHere?: boolean;
}

export class AdditionalIndicesChart extends React.Component<IAdditionalIndicesChartProps, {}> {
  private dataSeries = [
    {
      seriesId: 'giv',
      stateId: 'alwaysEnabled',
      name: 'GIV Index',
      colorByPoint: false,
      lineWidth: 3,
      fillOpacity: 0.1,
      connectNulls: true,
      label: {
        enabled: true,
      },
      data: [],
    },
    {
      seriesId: 'cpi',
      stateId: 'cpiEnabled',
      name: 'CPI +5.0%',
      colorByPoint: false,
      fillOpacity: 0.1,
      connectNulls: true,
      data: [],
    },
    {
      seriesId: 'sp',
      stateId: 'spEnabled',
      name: 'S & P 500',
      colorByPoint: false,
      fillOpacity: 0.1,
      data: [],
    },
    {
      seriesId: 'sf',
      stateId: 'sfEnabled',
      name: '60 / 40 Index',
      colorByPoint: false,
      fillOpacity: 0.1,
      data: [],
    },
    {
      seriesId: 'barclay',
      stateId: 'barclayEnabled',
      name: 'Barclays Aggr. Index',
      colorByPoint: false,
      fillOpacity: 0.1,
      data: [],
    },
    {
      seriesId: 'foundationmark',
      stateId: 'foundationMarkIndexEnabled',
      name: 'FoundationMark Index',
      colorByPoint: false,
      fillOpacity: 0.1,
      data: [],
    },
    {
      seriesId: 'appreciation',
      stateId: 'givAppreciationEnabled',
      name: 'GIV Appreciation',
      colorByPoint: false,
      color: '#A9D08E',
      marker: { enabled: false },
      fillOpacity: 0.1,
      type: 'line',
      data: [],
    },
    {
      seriesId: 'balanced',
      stateId: 'givBalancedEnabled',
      name: 'GIV Balanced',
      colorByPoint: false,
      marker: { enabled: false },
      color: '#BDD7EE',
      fillOpacity: 0.1,
      data: [],
    },
    {
      seriesId: 'other',
      stateId: 'givOtherEnabled',
      name: 'GIV Investment - Other',
      colorByPoint: false,
      color: '#8EA9DB',
      marker: { enabled: false },
      fillOpacity: 0.1,
      data: [],
    },
    {
      seriesId: 'preservation',
      stateId: 'givPreservationEnabled',
      name: 'GIV Preservation',
      colorByPoint: false,
      color: '#D9D9D9',
      marker: { enabled: false },
      fillOpacity: 0.1,
      data: [],
    },
    {
      seriesId: 'small',
      stateId: 'givSmallEnabled',
      name: '$1 mm - $10 mm Index',
      colorByPoint: false,
      fillOpacity: 0.1,
      data: [],
    },
    {
      seriesId: 'medium',
      stateId: 'givMediumEnabled',
      name: '$10 mm - $50 mm Index',
      colorByPoint: false,
      fillOpacity: 0.1,
      data: [],
    },
    {
      seriesId: 'large',
      stateId: 'givLargeEnabled',
      name: '$50+ mm Index',
      colorByPoint: false,
      fillOpacity: 0.1,
      data: [],
    },
  ];

  componentWillMount() {}

  componentDidMount() {
    this.getIndicesData();
  }

  getIndicesData() {
    const givTrendFilterBody = {
      assetLevel: 0,
      monthNumber: '12',
    };

    fetch('https://kbqk6mximj.execute-api.us-east-1.amazonaws.com/Test/publicindexdata', {
      method: 'POST',
      body: JSON.stringify(givTrendFilterBody),
    })
      .then((response) => {
        return response.text();
      })
      .then((text) => {
        text = text.replace(/u0026/g, '&');
        text = text.replace(/\\/g, '');
        return JSON.parse(text);
      })
      .then((json) => {
        const cpi = [];
        const sp = [];
        const sf = [];
        const barclay = [];
        const fm = [];
        const giv = [];
        const appreciation = [];
        const balanced = [];
        const preservation = [];
        const other = [];
        const small = [];
        const medium = [];
        const large = [];
        for (let period of json) {
          let date = period.date;
          cpi.push({ x: date, y: period.cpi });
          sp.push({ x: date, y: period.spfivehundred });
          sf.push({ x: date, y: period.sixtyforty });
          barclay.push({ x: date, y: period.barclays });
          fm.push({ x: date, y: period.foundationMarkIndex });
          giv.push({ x: date, y: period.giv });
          appreciation.push({ x: date, y: period.appreciationIndex });
          balanced.push({ x: date, y: period.balanceIndex });
          preservation.push({ x: date, y: period.preservationIndex });
          other.push({ x: date, y: period.otherIndex });
          small.push({ x: date, y: period.smallIndex });
          medium.push({ x: date, y: period.mediumIndex });
          large.push({ x: date, y: period.largeIndex });
        }

        this.setSeries('cpi', cpi);
        this.setSeries('sp', sp);
        this.setSeries('sf', sf);
        this.setSeries('barclay', barclay);
        this.setSeries('foundationmark', fm);
        this.setSeries('giv', giv);
        this.setSeries('appreciation', appreciation);
        this.setSeries('balanced', balanced);
        this.setSeries('preservation', preservation);
        this.setSeries('other', other);
        this.setSeries('small', small);
        this.setSeries('medium', medium);
        this.setSeries('large', large);

        this.setState({ tableData: json });
      });

    const tableFilterBody = {
      action: 'getPublicIndexTable',
      request: {
        assetLevel: 0,
        name: '',
        monthNumber: '12',
        dateStart: '',
        dateEnd: '',
      },
    };
    fetch('https://kbqk6mximj.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests', {
      method: 'POST',
      body: JSON.stringify(tableFilterBody),
    })
      .then((response) => {
        return response.text();
      })
      .then((text) => {
        text = text.replace(/u0026/g, '&');
        text = text.replace(/\\/g, '');
        return JSON.parse(text);
      })
      .then((json) => {
        this.setState({ indicies: json });
      });
  }

  setSeries(seriesId, seriesData) {
    const index = this.dataSeries.findIndex((series) => series.seriesId === seriesId);
    this.dataSeries[index]['data'] = seriesData;
  }

  roundToTenths(number: number) {
    return number.toLocaleString(undefined, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    });
  }

  getSeries() {
    return this.dataSeries.filter((series) => this.props[series.stateId] === true);
  }

  getPublicIndexConfig(series) {
    const { displayClickHere } = this.props;

    const title = displayClickHere
      ? '<b>Click <a style="color: #333" href="#/indices">here</a> for more interactive visualizations</b>'
      : '';

    return {
      chart: { type: 'area', height: 525 },
      title: {
        text: title,
        style: {
          fontSize: '1.6rem',
          color: '#00B050',
        },
        floating: true,
        x: 75,
        y: 150,
        align: 'left',
        useHTML: true,
      },
      yAxis: {
        title: { text: 'Index', style: { fontWeight: 'bold' } },
        min: 50,
      },
      xAxis: { type: 'datetime', max: Date.now() },
      legend: {
        enabled: true,
        padding: 12,
        align: 'left',
        verticalAlign: 'top',
        layout: 'proximate',
        x: 75,
        y: 25,
      },
      plotOptions: {
        area: {
          marker: {
            enabled: false,
          },
          label: {
            enabled: true,
          },
        },
        series: {
          events: {
            legendItemClick: function () {
              return false;
            },
          },
        },
      },
      tooltip: {
        headerFormat: '<b>{series.name}</b><br>',
        pointFormat: '',
      },
      credits: {
        enabled: false,
      },
      series,
    };
  }

  render() {
    const series = this.getSeries();
    return <ReactHighcharts config={this.getPublicIndexConfig(series)} ref="chart" />;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizations/AdditionalIndicesChart/index.tsx